<div class="grid-container">
    <div class="g-12 align:c m-24:b">
        <h1 class="c:white">Dein Kundenportal</h1>
    </div>
    <div class="g-12 p-48:b md:g-5 md:p-48:r md:p-0:b">
        <div class="sm-center">
            <img
                src="/assets/icons/icon_portal_big.svg"
                class="md:float:r"
                alt=""
                role="presentation"
            />
        </div>
    </div>
    <div class="portal-list g-12 md:g-7 c:white">
        <div class="sm-center p-24:h">
            <ul class="lg:fs:l">
                <li>Persönliche Daten ändern</li>
                <li>Schaden melden / Rechnung einreichen</li>
                <li>Bankdaten anpassen</li>
            </ul>
        </div>
    </div>
    <div class="button-container">
        @if (!isLoggedIn) {
            <a
                class="button"
                [routerLink]="['/', 'portal', 'dashboard']"
            >
                Login
            </a>
        }
        @if (isLoggedIn) {
            <a
                class="button"
                [routerLink]="['/', 'portal', 'dashboard']"
            >
                Mein Dashboard
            </a>
        }
    </div>
</div>
